import { XLg } from "react-bootstrap-icons";
import styles from "./FullScreenModal.module.scss";

interface Props {
  onClose: () => void;
  children: React.ReactNode;
  footer: React.ReactNode;
}

export default function FullScreenModal(props: Props) {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalBody}>
          <div />
          {/* Keep me! Left side padding. */}
          <div className={styles.modalBodyContent}>
            <div className={styles.closeButton}>
              <XLg className="text-muted" onClick={props.onClose} />
            </div>
            {props.children}
          </div>
          <div />
          {/* Keep me! Right side padding. */}
        </div>
        <div className={styles.modalFooter}>
          <div className={styles.footerContent}>{props.footer}</div>
        </div>
      </div>
    </div>
  );
}
